import { AxiosRequestConfig } from 'axios';
import { Api } from 'src/api';
import { httpConfig } from 'src/lib/modules/http';

const baseUrl = `${httpConfig.options.baseURL}/user-guiding`;

export interface UserGuidingPayload {
  attributes: Record<string, string | null | number | boolean>;
  company?: Record<string, string | null | number | boolean>;
}

export const payload = (
  userId: string,
  config?: AxiosRequestConfig,
): Promise<UserGuidingPayload> => Api.http.get(`${baseUrl}/${userId}/payload`, config);
